import type { PlatformConfig } from "@vybe/ui";
import { browserWindowsAdapter } from "@vybe/ui/platform/adapters/browser-windows";
import { webUpdatesAdapter } from "@vybe/ui/platform/adapters/web-updates";

export const webPlatformConfig: PlatformConfig = {
  platform: "web",
  hubUrl: import.meta.env.VITE_HUB_URL ?? "",
  llmBaseUrl: "",
  indicatorRuntimeBaseUrl: "",
  windows: browserWindowsAdapter,
  updates: webUpdatesAdapter,
};
